import { createReducer } from '@reduxjs/toolkit';
import fromPairs from 'lodash/fromPairs';
import set from 'lodash/set';

import { changeFilter } from '../actions';
import { CAMPAIGN_FILTER_TYPES } from '../utils/filter-utils';

export default createReducer(
  fromPairs(CAMPAIGN_FILTER_TYPES.map(({ name }) => [name, []])),
  {
    [changeFilter]: (state, { payload: { name, value } }) => {
      return set(state, name, value);
    },
  },
);
